import Vue from "vue";

export default {
  products: {
    async index(params) {
      const response = await Vue.prototype.$http.get(`/locacoes/produtos`, {
        params
      });

      return response.data;
    },

    async listarPorPreco() {
      const response = await Vue.prototype.$http.get(
        `/locacoes/produtos/listar_por_preco`
      );

      return response.data.data;
    },

    async create(payload) {
      const response = await Vue.prototype.$http.post(
        `/locacoes/produtos`,
        payload
      );

      return response.data.data;
    },

    async update(id, payload) {
      const response = await Vue.prototype.$http.put(
        `/locacoes/produtos/${id}`,
        payload
      );

      return response.data.data;
    },

    async atualizarQuantidadeTotal(id, payload) {
      const response = await Vue.prototype.$http.put(
        `/locacoes/produtos/${id}/quantidade_total`,
        payload
      );

      return response.data.data;
    },

    async destroy(id) {
      const response = await Vue.prototype.$http.delete(
        `/locacoes/produtos/${id}`
      );

      return response;
    }
  },

  locacoes: {
    async indexar(params) {
      const response = await Vue.prototype.$http.get(`/locacoes/locacoes`, {
        params
      });

      return response.data;
    },

    async indexarPorCliente(cliente_id) {
      const response = await Vue.prototype.$http.get(
        `/locacoes/locacoes/clientes/${cliente_id}`
      );

      return response.data;
    },

    async detalhar(id) {
      const response = await Vue.prototype.$http.get(
        `/locacoes/locacoes/${id}`
      );

      return response.data.data;
    },

    async iniciar(payload) {
      const response = await Vue.prototype.$http.post(
        `/locacoes/locacoes`,
        payload
      );

      return response.data.data;
    },

    async alterarCliente(id, payload) {
      const response = await Vue.prototype.$http.post(
        `/locacoes/locacoes/${id}/alterar_cliente`,
        payload
      );

      return response.data.data;
    },

    async alterarEndereco(codigo, payload) {
      const response = await Vue.prototype.$http.post(
        `/locacoes/locacoes/${codigo}/alterar_endereco`,
        payload
      );

      return response.data.data;
    },

    async cadastrarEndereco(codigo, payload) {
      const response = await Vue.prototype.$http.post(
        `/locacoes/locacoes/${codigo}/cadastrar_endereco`,
        payload
      );

      return response.data.data;
    },

    async fechar(id) {
      const response = await Vue.prototype.$http.post(
        `/locacoes/locacoes/${id}/fechar`
      );

      return response.data.data;
    },

    async aprovar(id) {
      const response = await Vue.prototype.$http.post(
        `/locacoes/locacoes/${id}/aprovar`
      );

      return response.data.data;
    },

    async reprovar(id) {
      const response = await Vue.prototype.$http.post(
        `/locacoes/locacoes/${id}/reprovar`
      );

      return response.data.data;
    },

    async cancelar(id) {
      const response = await Vue.prototype.$http.delete(
        `/locacoes/locacoes/${id}`
      );

      return response;
    },

    async adicionarProduto(locacao_id, payload) {
      const response = await Vue.prototype.$http.post(
        `/locacoes/locacoes/${locacao_id}/adicionar_produto`,
        payload
      );

      return response.data.data;
    },

    async removerProduto(locacao_id, produto_id) {
      const response = await Vue.prototype.$http.delete(
        `/locacoes/locacoes/${locacao_id}/remover_produto/${produto_id}`
      );

      return response.data.data;
    },

    async atualizarProduto(locacao_id, produto_id, payload) {
      const response = await Vue.prototype.$http.put(
        `/locacoes/locacoes/${locacao_id}/atualizar_produto/${produto_id}`,
        payload
      );

      return response.data.data;
    },

    async atualizarFormaDePagamento(locacao_id, payload) {
      const response = await Vue.prototype.$http.post(
        `/locacoes/locacoes/${locacao_id}/atualizar_forma_de_pagamento`,
        payload
      );

      return response.data.data;
    },

    async atualizarComprador(locacao_id, payload) {
      const response = await Vue.prototype.$http.post(
        `/locacoes/locacoes/${locacao_id}/atualizar_comprador`,
        payload
      );

      return response.data.data;
    },

    async realocar(payload) {
      const response = await Vue.prototype.$http.post(
        `/locacoes/locacoes/realocar`,
        payload
      );

      return response.data.data;
    },

    async marcarComoPago(locacao_id, payload) {
      const response = await Vue.prototype.$http.post(
        `/locacoes/locacoes/${locacao_id}/marcar_como_pago`,
        payload
      );

      return response.data.data;
    },

    async marcarComoNaoPago(locacao_id) {
      const response = await Vue.prototype.$http.post(
        `/locacoes/locacoes/${locacao_id}/marcar_como_nao_pago`
      );

      return response.data.data;
    }
  },

  locacoes_produtos: {
    historico(locacao_produto_id) {
      return Vue.prototype.$http.get(
        `/locacoes/locacao_produto/${locacao_produto_id}/historico`
      );
    }
  },

  locais_de_estoque: {
    async indexar(filter) {
      const response = await Vue.prototype.$http.get(
        `/locacoes/locais_estoque`,
        {
          query: {
            filter
          }
        }
      );

      return response.data.data;
    },

    async adicionar(form) {
      const response = await Vue.prototype.$http.post(
        `/locacoes/locais_estoque`,
        form
      );

      return response.data.data;
    },

    async exibir(id) {
      const response = await Vue.prototype.$http.get(
        `/locacoes/locais_estoque/${id}`
      );

      return response.data.data;
    },

    async atualizar(id, form) {
      const response = await Vue.prototype.$http.put(
        `/locacoes/locais_estoque/${id}`,
        form
      );

      return response.data.data;
    },

    async remover(id) {
      const response = await Vue.prototype.$http.delete(
        `/locacoes/locais_estoque/${id}`
      );

      return response.data;
    },

    async indexarLocaisPorProduto(produto_id) {
      const response = await Vue.prototype.$http.get(
        `locacoes/locais_estoque/por_produto/${produto_id}`
      );

      return response.data.data;
    },

    async indexarProdutos(id) {
      const response = await Vue.prototype.$http.get(
        `/locacoes/locais_estoque/${id}/produtos`
      );

      return response.data.data;
    },

    async adicionarProduto(id, payload) {
      const response = await Vue.prototype.$http.post(
        `/locacoes/locais_estoque/${id}/produtos/adicionar`,
        payload
      );

      return response.data.data;
    },

    async removerProduto(id, payload) {
      const response = await Vue.prototype.$http.post(
        `/locacoes/locais_estoque/${id}/produtos/remover`,
        payload
      );

      return response.data.data;
    },

    async transferirProduto(id, payload) {
      const response = await Vue.prototype.$http.post(
        `/locacoes/locais_estoque/${id}/produtos/transferir`,
        payload
      );

      return response.data.data;
    },

    async buscarOuCriar(payload) {
      const response = await Vue.prototype.$http.post(
        `/locacoes/locais_estoque/buscar_ou_criar`,
        payload
      );

      return response.data.data;
    }
  },

  transferencias: {
    async indexar(params) {
      const response = await Vue.prototype.$http.get(
        `/locacoes/transferencias`,
        { params }
      );

      return response.data;
    },

    async indexarPorLocalDeEstoque(local_de_estoque_id, params) {
      const response = await Vue.prototype.$http.get(
        `/locacoes/transferencias/local_de_estoque/${local_de_estoque_id}`,
        { params }
      );

      return response.data;
    },

    async adicionar(payload) {
      const response = await Vue.prototype.$http.post(
        `/locacoes/transferencias`,
        payload
      );

      return response.data.data;
    },

    async transferir(id) {
      const response = await Vue.prototype.$http.post(
        `/locacoes/transferencias/${id}/transferir`
      );

      return response.data.data;
    },

    async remover(id) {
      const response = await Vue.prototype.$http.delete(
        `/locacoes/transferencias/${id}`
      );

      return response;
    }
  },

  transportes: {
    async listarTodos(params) {
      const response = await Vue.prototype.$http.get(
        `/locacoes/transportes/todos`,
        {
          params
        }
      );

      return response.data;
    },
    async listarEntregas(params) {
      const response = await Vue.prototype.$http.get(
        `/locacoes/transportes/entregas`,
        {
          params
        }
      );

      return response.data;
    },
    async listarRecolhimentos(params) {
      const response = await Vue.prototype.$http.get(
        `/locacoes/transportes/recolhimentos`,
        {
          params
        }
      );

      return response.data;
    }
  },

  ordens_transporte: {
    async listarTodos() {
      const response = await Vue.prototype.$http.get(
        `/locacoes/ordens_transporte/todos`
      );

      return response.data.data;
    },
    async exibir(id) {
      const response = await Vue.prototype.$http.get(
        `/locacoes/ordens_transporte/${id}`
      );

      return response.data.data;
    },
    async cadastrar(payload) {
      const response = await Vue.prototype.$http.post(
        `/locacoes/ordens_transporte`,
        payload
      );

      return response.data.data;
    },
    async confirmar(id, payload) {
      const response = await Vue.prototype.$http.post(
        `/locacoes/ordens_transporte/${id}/confirmar`,
        payload
      );

      return response.data.data;
    },
    async cancelar(id) {
      const response = await Vue.prototype.$http.delete(
        `/locacoes/ordens_transporte/${id}`
      );

      return response.data;
    },

    async confirmarItem(id, payload) {
      const response = await Vue.prototype.$http.post(
        `/locacoes/ordens_transporte/itens/${id}/confirmar`,
        payload
      );

      return response.data.data;
    },
    async atualizarItem(id, payload) {
      const response = await Vue.prototype.$http.put(
        `/locacoes/ordens_transporte/itens/${id}`,
        payload
      );

      return response.data.data;
    },
    async atualizarData(id, payload) {
      const response = await Vue.prototype.$http.put(
        `/locacoes/ordens_transporte/itens/${id}/data`,
        payload
      );

      return response.data.data;
    },
    async removerItem(id) {
      const response = await Vue.prototype.$http.delete(
        `/locacoes/ordens_transporte/itens/${id}`
      );

      return response.data;
    }
  },

  precos_produto: {
    async calcularPorData(produto_id, payload) {
      const response = await Vue.prototype.$http.post(
        `/locacoes/precos_produto/calcular_por_data/${produto_id}`,
        payload
      );

      return response.data.data;
    },

    async listarPorProduto(produto_id) {
      const response = await Vue.prototype.$http.get(
        `/locacoes/precos_produto/${produto_id}`
      );

      return response.data.data;
    },

    async adicionarOuAtualizar(produto_id, dias, payload) {
      const response = await Vue.prototype.$http.post(
        `/locacoes/precos_produto/${produto_id}/${dias}`,
        payload
      );

      return response.data.data;
    },

    async remover(produto_id, dias) {
      const response = await Vue.prototype.$http.delete(
        `/locacoes/precos_produto/${produto_id}/${dias}`
      );

      return response.data;
    }
  },

  pagamentos: {
    async indexar(params) {
      const response = await Vue.prototype.$http.get(`/locacoes/pagamentos`, {
        params
      });

      return response.data;
    },

    async retirarPagamento(payload) {
      const response = await Vue.prototype.$http.post(
        `/locacoes/pagamentos/retirar_pagamento`,
        payload
      );

      return response.data;
    },

    async indexarRetirados(params) {
      const response = await Vue.prototype.$http.get(
        `/locacoes/pagamentos/retiradas`,
        {
          params
        }
      );

      return response.data;
    },

    async exibirRetirados(id) {
      const response = await Vue.prototype.$http.get(
        `/locacoes/pagamentos/retiradas/${id}`
      );

      return response.data;
    },

    async atualizarRetirados(id, payload) {
      const response = await Vue.prototype.$http.put(
        `/locacoes/pagamentos/retiradas/${id}`,
        payload
      );

      return response.data;
    },

    async reverterRetirada(id) {
      const response = await Vue.prototype.$http.delete(
        `/locacoes/pagamentos/retiradas/${id}`
      );

      return response;
    }
  },

  relatorios: {
    async pagamentosRecebidos(params) {
      const response = await Vue.prototype.$http.get(
        `/locacoes/relatorios/pagamentos`,
        {
          params
        }
      );

      return response.data;
    }
  }
};
